import { COOKIE_TOKEN, STORAGE_LNG, STORAGE_USER_PROFILE } from "config/const/global";
import { EN, FALLBACK_LNG, ZH, ZH_CN } from "config/const/locale";
import { getCookie } from "utils/cookies";
import i18n from "config/i18n";
import { isEmpty } from "lodash";

const { createSlice } = require("@reduxjs/toolkit");

const ltoken = getCookie(COOKIE_TOKEN) || ''
const previous_lng = localStorage.getItem(STORAGE_LNG) || ''
const previous_userProfile = localStorage.getItem(STORAGE_USER_PROFILE) || ''


// all global state
const globalSlice = createSlice({
    name: "global",
    initialState: {
        token: ltoken, // save the login token 
        lng: previous_lng, // language flag
        user: isEmpty(previous_userProfile) ? {} : JSON.parse(previous_userProfile), // user profile
    },
    reducers: {
        // token handler
        tokenHandler(state, action) {
            if (action.payload.switch) state.token = action.payload.newToken
            else state.token = ''
        },

        // language setter
        LngSetter(state, action) {
            const { lng } = action.payload
            state.lng = lng
            localStorage.setItem(STORAGE_LNG, lng)

            switch (lng) {
                case ZH:
                    i18n.changeLanguage(ZH)
                    break;
                case ZH_CN:
                    i18n.changeLanguage(ZH_CN)
                    break;
                case EN:
                    i18n.changeLanguage(EN)
                    break;

                default:
                    state.lng = FALLBACK_LNG
                    localStorage.setItem(STORAGE_LNG, FALLBACK_LNG)
                    i18n.changeLanguage(FALLBACK_LNG)
                    break;
            }
        },

        userProfileSetter(state, action) {
            state.user = action.payload
        }
    }
})

export const {
    tokenHandler,
    LngSetter,
    userProfileSetter
} = globalSlice.actions
export default globalSlice